import { selectLoggedinUserName, selectLoggedinUserPhone } from 'accessors'
import { SecondaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useInternalAdmin } from 'hooks'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import campaignApi from 'services/api/campaign'
import {
  getApiErrorMessage,
  showTestSmsErrorToast,
  showTestSmsResultToast
} from 'services/helpers/campaignApiHelpers'

import styles from './EmailEditor.module.scss'

const fullNameRegex = /^[A-Za-z]+(?: [A-Za-z]+)+$/

const TestSms = ({
  contentCategory,
  contentId,
  onBeforeSend,
  restrictToInternalAdmin = true
}) => {
  const isInternalAdmin = useInternalAdmin()
  const userPhone = useSelector(selectLoggedinUserPhone)
  const userName = useSelector(selectLoggedinUserName)
  const { addToast } = useToasts()

  const [phoneToSend, setPhoneToSend] = useState(userPhone || '')
  const [isSending, setIsSending] = useState(false)

  const normalizedUserPhone = (userPhone || '').replace(/\D/g, '')
  const normalizedTarget = (phoneToSend || '').replace(/\D/g, '')
  const isOwnPhone =
    normalizedUserPhone.length > 0 && normalizedTarget === normalizedUserPhone

  const handleSendTestSms = async () => {
    if (!normalizedTarget) {
      addToast('Enter a phone number to receive the test text.', {
        appearance: 'error',
        autoDismiss: true
      })
      return
    }

    const guestName = userName && fullNameRegex.test(userName) ? userName : 'Test Guest'

    setIsSending(true)

    try {
      if (onBeforeSend) {
        await onBeforeSend()
      }
    } catch (error) {
      const reason = getApiErrorMessage(error)
      addToast(
        reason
          ? `Could not save your latest changes before sending the test: ${reason}`
          : 'Could not save your latest changes before sending the test. Please try again.',
        { appearance: 'error', autoDismiss: true }
      )
      setIsSending(false)
      return
    }

    const request =
      isOwnPhone && contentCategory
        ? campaignApi.sendTestSms({ contentCategory, contentId })
        : campaignApi.sendTestSmsToAnotherNumber({
            contentCategory,
            contentId,
            phoneNumber: phoneToSend,
            guestName
          })

    request
      .then(response => {
        showTestSmsResultToast(
          addToast,
          response,
          phoneToSend,
          `Test text sent successfully to ${phoneToSend}.`
        )
      })
      .catch(error => {
        showTestSmsErrorToast(addToast, error, 'Failed to send test text.')
      })
      .finally(() => {
        setIsSending(false)
      })
  }

  if (restrictToInternalAdmin && !isInternalAdmin) {
    return null
  }

  return (
    <div className={styles.emailTestHolder}>
      <p className={styles.emailTestTitle}>Test your text message</p>
      <div className={styles.emailTestForm}>
        <TextInput
          type="tel"
          value={phoneToSend}
          onChangeValue={value => setPhoneToSend(value)}
        />
        <SecondaryRegularButton onClick={handleSendTestSms} disabled={isSending}>
          {isSending ? 'Sending...' : 'Send Test Text'}
        </SecondaryRegularButton>
      </div>
    </div>
  )
}

export default TestSms
